import Vue from 'vue';
import App from './App.vue';
import i18n from './translations/i18n';
import router from './router';
import store from './store';
import './class-component-hooks';
import './_global';
import './components/base';
import './_registerAxios';
import './filters';
import './plugins';
import './registerServiceWorker';
import './lib/online';

// Vue.config.performance = true;
Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
